import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "top_right", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 6", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M3.5 2.5h-2a1 1 0 110-2h3a1 1 0 011 1v3a1 1 0 11-2 0v-2z", fill: "#FFF", stroke: "red" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
